
import React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { MapPin } from 'lucide-react';
import { MatchCompatibility } from '@/types';

interface SwipeCardHeaderProps {
  name: string;
  role: string;
  location: string;
  matchScore?: MatchCompatibility;
}

const SwipeCardHeader: React.FC<SwipeCardHeaderProps> = ({
  name,
  role,
  location,
  matchScore
}) => {
  const getCompatibilityColor = (score: number) => {
    if (score >= 90) return 'text-green-500';
    if (score >= 80) return 'text-emerald-500';
    if (score >= 70) return 'text-yellow-500';
    return 'text-orange-500';
  };

  return (
    <CardHeader>
      <div className="flex justify-between items-start">
        <div>
          <CardTitle className="text-2xl flex items-center gap-2">
            {name}
            <Badge variant="outline" className="ml-2 text-xs">
              {role}
            </Badge>
          </CardTitle>
          <div className="flex items-center gap-1 text-muted-foreground">
            <MapPin className="h-3 w-3" />
            {location}
          </div>
        </div>
        <div className={`text-xl font-bold ${getCompatibilityColor(matchScore?.score || 0)}`}>
          {matchScore?.score}%
          <div className="text-xs font-normal text-muted-foreground">match</div>
        </div>
      </div>
    </CardHeader>
  );
};

export default SwipeCardHeader;
